import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './index.css';
//import App from './App';
import Home from './pages/Home';
import Tickets from './pages/Tickets';
import Navbar from './components/Navbar';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Navbar/>}>
          <Route index element={<Home />} />
          <Route path='tickets' element={<Tickets />} />
        </Route>
      </Routes>
    </Router>
  )
}